<div class="dropdown">
  <app-searchable-select [options]="searchOptions"
                         [value]="selectedKey"
                         [invalid]="control.invalid"
                         [disabled]="control.disabled"
                         [dataField]="field?.fieldUuid"
                         [dataTypeId]="field?.config?.typeId"
                         [ariaLabel]="field?.config?.label"
                         (valueChange)="onSearchSelected($event)"></app-searchable-select>
</div>
